import { createBreakpoints } from "@mui/system";

const breakpointValues = {
  xs: 0,
  sm: 375,
  md: 768,
  lg: 1280,
  xl: 1440,
};

const breakpoints = createBreakpoints({ values: breakpointValues });
export default breakpoints;
